import { useEffect, useState } from "react";
import { showMessage } from "../../Functionalities/Functions";
import { fetchUmbrellas } from "./umbrellaData";

export default function useUmbrellaList() {
  const [query, setQuery] = useState({ review: false, search: "", page: 1 });
  const [version, setVersion] = useState(0);
  const [data, setData] = useState({ count: 0, results: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let live = true;
    setLoading(true);
    fetchUmbrellas(query).then((reply) => {
      if (!live) return;
      setLoading(false);
      if (reply.error) showMessage(reply.error, "danger", "Could not load the categories", "top", "top-right", 0);
      else setData(reply);
    });
    return () => {
      live = false;
    };
  }, [query, version]);

  return {
    query,
    data,
    loading,
    reload: () => setVersion((n) => n + 1),
    showTab: (review) => setQuery({ ...query, review, page: 1 }),
    search: (search) => setQuery({ ...query, search, page: 1 }),
    showPage: (page) => setQuery({ ...query, page }),
  };
}
